import { CaseFile, CaseLinkType } from '@/api/apis/case';
import { useSummaryFilesUpload } from '@/hooks/useSummaryFilesUpload';
import { useAddLink, useChangeLink, useDeleteLink } from '@/queries/case';
import { AttachmentsModal } from './AttachmentsModal';

type CaseAttachmentsModalProps = {
  caseId: string;
  files: CaseFile[];
  links: CaseLinkType[];
  onOpenChange: () => void;
  disabled?: boolean;
  showUploadBtn?: boolean;
  showDownloadBtn?: boolean;
  showDeleteBtn?: boolean;
  showEditBtn?: boolean;
  restrictRedactedFileDelete?: boolean;
  showRedactedMark?: boolean;
  hintLabel?: string;
  hintText?: string;
  requireRedactionConfirmation?: boolean;
  showRedactionInstructions?: boolean;
};

export const CaseAttachmentsModal = ({
  caseId,
  onOpenChange,
  links,
  files,
  disabled,
  showUploadBtn,
  showDownloadBtn,
  showDeleteBtn,
  showEditBtn,
  restrictRedactedFileDelete,
  showRedactedMark,
  hintLabel,
  hintText,
  requireRedactionConfirmation,
  showRedactionInstructions,
}: CaseAttachmentsModalProps) => {
  const { deleteFile, handleFileUpload, isUploading } = useSummaryFilesUpload({ caseId });
  const { mutateAsync: addLink, isPending: addLinkPending } = useAddLink();
  const { mutateAsync: editLink, isPending: editLinkPending } = useChangeLink();
  const { mutateAsync: deleteLink, isPending: deleteLinkPending } = useDeleteLink();

  return (
    <AttachmentsModal
      files={files}
      links={links}
      onOpenChange={onOpenChange}
      fileUpload={{ isUploading, onFileUpload: handleFileUpload, onDeleteFile: deleteFile }}
      linkMutations={{
        addLink: (linkData) => addLink({ caseId, linkData }),
        editLink: (linkId, linkData) => editLink({ caseId, linkId, linkData }),
        deleteLink: (linkId) => deleteLink({ caseId, linkId }),
        isPending: addLinkPending || editLinkPending || deleteLinkPending,
      }}
      disabled={disabled}
      showUploadBtn={showUploadBtn}
      showDownloadBtn={showDownloadBtn}
      showDeleteBtn={showDeleteBtn}
      showEditBtn={showEditBtn}
      restrictRedactedFileDelete={restrictRedactedFileDelete}
      showRedactedMark={showRedactedMark}
      hintLabel={hintLabel}
      hintText={hintText}
      requireRedactionConfirmation={requireRedactionConfirmation}
      showRedactionInstructions={showRedactionInstructions}
    />
  );
};
